import { useQuery } from '@tanstack/react-query';
import { getTerminalProducts } from '../../services/business';

function useGetTerminalProducts() {
  return useQuery({
    queryKey: ['terminal-products'],
    queryFn: getTerminalProducts,
  });
}

export default useGetTerminalProducts;
